module.exports = __webpack_public_path__ + "img/DAVID_CANNON_29-rs.9d72edb4.jpg";